import { Injectable } from '@angular/core';
import { RestDeviceService } from 'src/app/service/rest/device/rest-device.service';
import { DeviceHistory } from './device.model';

@Injectable()
export class DeviceHistoryRepositoryService {

  private _deviceHistory: DeviceHistory[] = [];

  constructor(private restDevice : RestDeviceService) { }

  public get deviceHistory(): DeviceHistory[] {
    return this._deviceHistory;
  }
  public set deviceHistory(value: DeviceHistory[]) {
    this._deviceHistory = value;
  }

  loadDeviceHistory(id: string) {
    this.restDevice.getDeviceHistoryByDeviceId(id)
      .subscribe((result: DeviceHistory[]) => {
        if (result) {
          result.forEach((deviceHistory, index) => {
            if (deviceHistory.eventDate) deviceHistory.eventDate = new Date(deviceHistory.eventDate?.toString());
          });
        }
        this.deviceHistory = result;
      })
  }

  getHistoryDates() {
    return this.deviceHistory
      .map(history => history.eventDate)
      .filter((ele, index, array) => array.findIndex(i => i.setHours(0,0,0,0) === ele.setHours(0,0,0,0)) == index)
      .sort((a, b) => (a > b ? -1 : 1));
  }

  getHistoriesByDate(date: Date): DeviceHistory[] {
    return this.deviceHistory.filter(history => date == undefined || history.eventDate.setHours(0,0,0,0) == date.setHours(0,0,0,0));
  }
}
